import { useQuery } from '@apollo/client/react';
import { type BasicStoreFragment, GetStoresDocument } from '@drycut/graphql';
import { Stack } from '@drycut/ui-components';

import SalonCard from './SalonCard';

export function SalonIndex(): React.ReactElement {
  const { data } = useQuery(GetStoresDocument);

  const stores = data?.stores?.nodes || [];
  const validStores = stores.filter((node): node is BasicStoreFragment => Boolean(node));

  return (
    <Stack className="h-screen justify-center p-10 items-center">
      <div className="grid grid-cols-2 gap-10 container">
        {validStores.map((store) => (
          <SalonCard key={store.id} salon={store} />
        ))}
      </div>
    </Stack>
  );
}
